import { StarRouter } from './router/StarRouter';
import * as React from 'react';
import { makeAutoObservable } from 'mobx';
import { css } from '@emotion/react';
import { RhsTabs } from 'src/domains/players/webview/components/Account/rhsMenu/RhsTabs';
import { ModalState } from 'src/domains/layouts/webview/components/modals/Modal.state';
import { modalRhsMenu } from 'src/domains/layouts/webview/components/modals/Layer.style';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { BannersBoxState } from 'src/domains/layouts/state/bannersBoxState/BannersBoxState';
import { Common } from 'src/domains/common/Common';

export class AccountDrawerNew {
    public constructor(
        private bannersBoxState: BannersBoxState,
        private modalState: ModalState,
        private readonly common: Common
    ) {
        makeAutoObservable(this);
        this.initOnChangeAccountView();
    }

    private initOnChangeAccountView(): void {
        StarRouter.get(this.common).onChangeAccountView(async (_prevView, nextView) => {
            if (nextView === null) {
                return;
            }

            const account = nextView.account;

            if (account === null) {
                return;
            }
            const env = EnvironmentState.get(this.common);
            this.modalState.show({
                layerCss: () => modalRhsMenu(this.bannersBoxState, env.emotionTheme),
                contentCss: css``,
                animation: 'right',
                content: <RhsTabs tab={nextView} />,
                overlayOnClick: 'closeAll',
            });
        });
    }
}
